import { paletteHelper, spacingHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { formatPriceToShorthandPrice } from '../../../../../app-kit/helpers/prices';
import { QuestionTooltip } from '../../../../../components/QuestionTooltip/QuestionTooltip';
import {
  formatYearlyTick,
  getYearlyXAxisTicks,
} from '../../../../../components/TimeseriesAreaGraph/helpers/axes';
import { TimeseriesAreaGraph } from '../../../../../components/TimeseriesAreaGraph/TimeseriesAreaGraph';
import { MarketInsightsMedianCostSubBrick } from '../../types';
import { AdditionalDetails } from '../AdditionalDetails/AdditionalDetails';
import { CostChange } from '../CostChange/CostChange';

const TitleText = styled(Text)`
  ${typographyHelper('subtitle02')};
`;

const SubtitleText = styled(Text)`
  ${typographyHelper('subtitle02')};
  color: ${paletteHelper('textSecondary')};
  height: ${spacingHelper('twoExtraLarge')};
`;

const CostValue = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const CostTitle = styled(Text)`
  line-height: 2rem;
`;

const CostSuffix = styled(Text)`
  margin-left: ${spacingHelper('twoExtraSmall')};
`;

const TrendGraph = styled(TimeseriesAreaGraph)`
  margin-top: ${spacingHelper('extraLarge')};
`;

interface MedianPriceSubBrickProps extends MarketInsightsMedianCostSubBrick {
  graphId: string;
}

export const MedianCostSubBrick: FunctionComponent<MedianPriceSubBrickProps> = ({
  title,
  subtitle,
  cost,
  costChange,
  disclaimer,
  additionalDetails,
  graph,
  graphId,
}) => {
  return (
    <ContentBrick
      titleComponent={<TitleText as="h3">{title}</TitleText>}
      subtitleComponent={<SubtitleText>{subtitle}</SubtitleText>}
      isSubBrick={true}
      headerChildren={
        <QuestionTooltip inPageSource="suburb_page__median_price_brick___disclaimer_link">
          {disclaimer}
        </QuestionTooltip>
      }
    >
      <CostValue>
        <CostTitle variant="title02">{cost.title}</CostTitle>
        {cost.suffix && <CostSuffix variant="subtitle01">{cost.suffix}</CostSuffix>}
      </CostValue>
      {costChange && <CostChange {...costChange} />}
      <TrendGraph
        title={title}
        graph={graph}
        graphId={graphId}
        formatXAxisValue={formatYearlyTick}
        formatValueFn={formatPriceToShorthandPrice}
        getXAxisTicks={getYearlyXAxisTicks}
      ></TrendGraph>
      {additionalDetails && additionalDetails.length > 0 && (
        <AdditionalDetails additionalDetails={additionalDetails} />
      )}
    </ContentBrick>
  );
};
